var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 51C102 79.1665 79.1665 102 51 102C22.8335 102 0 79.1665 0 51C0 22.8335 22.8335 0 51 0C79.1665 0 102 22.8335 102 51Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1051 76.5H67.4886C68.0621 76.5 68.5312 76.0217 68.5312 75.437V73.8106C68.5312 71.8973 67.2801 70.2922 65.5597 69.7607C65.5701 69.6969 65.6014 69.6331 65.6014 69.5587V67.5816C65.6014 66.7418 65.2782 65.9871 64.7569 65.4237C66.227 64.1162 68.3331 61.3525 68.3331 56.2395C68.3331 51.1266 63.1408 46.7258 58.5636 43.016C56.2072 41.1026 53.7779 39.1361 53.0376 37.6267C54.9248 37.3503 56.5305 36.1704 57.4167 34.5227C51.7969 36.5637 48.1685 28.7401 53.194 25.583C45.6557 24.4457 43.3828 35.3306 50.6187 37.4778C49.9618 39.0085 47.4595 41.0388 45.0301 43.016C40.4529 46.7258 35.2606 50.9352 35.2606 56.2395C35.2606 61.5438 37.3667 64.1162 38.8369 65.4237C38.3155 65.9977 37.9923 66.7524 37.9923 67.5816C37.9923 67.656 37.961 69.7819 38.034 69.7607C36.3241 70.2922 35.0625 71.8973 35.0625 73.8106V75.437C35.0625 76.0217 35.5317 76.5 36.1051 76.5Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogo);
export default __webpack_public_path__ + "static/media/default-logo.f243cb9bf5de08f5906a6df2252a769b.svg";
export { ForwardRef as ReactComponent };